// extracted by mini-css-extract-plugin
export default {"container":"LinkExpiredPage_container__VZwgx","title":"LinkExpiredPage_title__8MW7P","description":"LinkExpiredPage_description__flBpy"};